import { gcApi } from 'config/axios';
import Moment from 'moment';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import DateFormatter from 'utils/date/DateFormatter';

// utils

import {
    FETCH_CHALLENGE,
    FETCH_CHALLENGE_FAIL,
    FETCH_CHALLENGE_SUCCESS,
    JOIN_CHALLENGE,
    JOIN_CHALLENGE_FAIL,
    JOIN_CHALLENGE_SUCCESS,
    LEAVE_CHALLENGE,
    LEAVE_CHALLENGE_SUCCESS,
    LEAVE_CHALLENGE_FAIL,
    BADGE_CHALLENGE_DETAIL_OPT_IN_AUTO_CHALLENGE,
    BADGE_CHALLENGE_DETAIL_UPDATE_AUTO_CHALLENGE
} from 'actions/ActionTypes';

import { navigateToSubscriptionPage } from 'GCP/utils/GCPNavigationUtil';

export function* fetchChallengeSaga(action) {
    try {
        let url = `/badgechallenge-service/badgeChallenge/${action.challengeId}`;
        const response = yield call(gcApi.get, url);

        /** only call when response data has autoChallengeLink */
        let autoChallengeRes = { data: null };
        if (response.data?.autoChallengeLink) {
            autoChallengeRes = yield call(gcApi.get, `/challenge-service/challenge/active`);
        }

        yield put({
            type: FETCH_CHALLENGE_SUCCESS,
            challenge: response.data,
            autoChallenge: autoChallengeRes.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CHALLENGE_FAIL,
            challenge: {}
        });
    }
}

export function* joinChallengeSaga(action) {
    try {
        const todayDate = Moment().format(DateFormatter.LINK_FORMAT);
        let url = `/badgechallenge-service/badgeChallenge/${action.challengeId}/optIn/${todayDate}`;
        const response = yield call(gcApi.post, url, {
            headers: {
                'Content-Type': 'text/html'
            }
        });

        yield put({
            type: JOIN_CHALLENGE_SUCCESS
        });

        yield put({
            type: FETCH_CHALLENGE,
            challengeId: action.challengeId
        });
    } catch (e) {
        if (e.response.status === 402) {
            // to paywall
            const featureUrl = window.location.pathname;
            navigateToSubscriptionPage(featureUrl);
        }
        yield put({
            type: JOIN_CHALLENGE_FAIL,
            error: e.response.data
        });
    }
}

export function* leaveChallengeSaga(action) {
    try {
        let url = `/badgechallenge-service/badgeChallenge/${action.challengeId}/optOut`;
        const response = yield call(gcApi.post, url, {
            headers: {
                'Content-Type': 'text/html'
            }
        });

        yield put({
            type: LEAVE_CHALLENGE_SUCCESS
        });
    } catch (e) {
        yield put({
            type: LEAVE_CHALLENGE_FAIL
        });
    }
}

export function* optInAutoChallengeSaga(action) {
    const callback = typeof action.callback === 'function' ? action.callback : () => {};
    try {
        /** join auto challenge */
        yield call(gcApi.post, '/userprofile-service/userprofile/optional-feature/wellness-autoleaderboard/opt-in', {});

        /** fetch latest response */
        const response = yield call(gcApi.get, `/challenge-service/challenge/active`);
        yield put({
            type: BADGE_CHALLENGE_DETAIL_UPDATE_AUTO_CHALLENGE,
            data: response.data
        });
        callback(null);
    } catch (error) {
        callback(error);
    }
}

export const challenge = [
    takeEvery(FETCH_CHALLENGE, fetchChallengeSaga),
    takeEvery(JOIN_CHALLENGE, joinChallengeSaga),
    takeEvery(LEAVE_CHALLENGE, leaveChallengeSaga),
    takeLatest(BADGE_CHALLENGE_DETAIL_OPT_IN_AUTO_CHALLENGE, optInAutoChallengeSaga)
];
